import { render, staticRenderFns } from "./classManage.vue?vue&type=template&id=13a9e4a5&scoped=true&"
import script from "./classManage.vue?vue&type=script&lang=js&"
export * from "./classManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a9e4a5",
  null
  
)

export default component.exports